import { Component, Input } from '@angular/core';

@Component({
  selector: 'rl-lti-relink',
  templateUrl: './lti-relink.component.html',
})
export class LtiRelinkComponent {
  @Input() ltiRelinkUrl: string;
}
